import type { CreatorCollaborationPackage, CreatorPlacement } from './model';

/** Resolve persisted quote types without rewriting delivery data or invitation options. */
export function getCreatorSubmittedContentType(
  pkg: CreatorCollaborationPackage,
  placement: CreatorPlacement,
  historyRecord?: Record<string, any>
): string | undefined {
  const history = pkg.raw.negotiationHistory;
  if (!Array.isArray(pkg.raw.channels) || !Array.isArray(history)) {
    return placement.contentType;
  }
  const latest = historyRecord ?? history[history.length - 1];
  let submittedType: unknown;
  if (Array.isArray(latest?.channels)) {
    // Never match repeated platforms/accounts by their position or display name.
    const channel = latest.channels.find(
      (item: Record<string, any>) =>
        item?.channelKey === (placement.channelKey || placement.id)
    );
    if (channel && !channel.removed) submittedType = channel.contentType;
  } else if (
    pkg.raw.channels.length === 1 &&
    pkg.placements.length === 1 &&
    (!pkg.raw.platform ||
      String(pkg.raw.platform).trim().toLowerCase() === placement.platform)
  ) {
    // Historical single-channel quotes have no channels snapshot. Their rate
    // calculation retains the submitted type; it is not a package-wide type.
    submittedType = latest?.overRateCap?.contentType;
  }
  return typeof submittedType === 'string' && submittedType.trim()
    ? submittedType.trim()
    : placement.contentType;
}
